import { jsx as _jsx } from "react/jsx-runtime";
import { ActionIconPlus } from '@klarna/bubble-ui';
function CustomActionClose() {
    return (_jsx(ActionIconPlus, { UNSAFE_svgProps: { style: { position: 'relative', top: 2, margin: '0 4px' } } }));
}
export default CustomActionClose;
